import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <img
        src="/How2Play_mainLogo128.png"
        alt="Loading"
        className="logo-spin"
      />
    </div>
  );
};

export default LoadingSpinner;
